<template>
  <ul class="sc-aewfc lhblLm">
    <li
      class=" xsa-iRXnRJ "
      v-for="(i, index) in routelist"
      :key="index"
      :class="{ curr: $route.path.includes(i.path) }"
      :style="i.style"
    >
      <img
        draggable="false"
        :src="$route.path.includes(i.path) ? i.img2 : i.img"
      />
      <router-link :to="{ path: `/Center${i.path}` }">{{ i.name }}</router-link>
    </li>
    <li id="tuichu">
      <div class="sc-dv pmds jKBcuJ" @click="fClose">
        <span class="sc-dBAPYN cnjqmx"></span>退出
      </div>
    </li>
  </ul>
</template>

<script>
export default {
  data () {
    return {
      routelist: [{
        name: '账号中心',
        path: '/Information',
        img: '../../static/percttent/hui/1.png',
        img2: '../../static/percttent/hei/1.png'
      },
      {
        name: '我的卡包',
        path: '/card',
        img: '../../static/percttent/hui/2.png',
        img2: '../../static/percttent/hei/2.png',
        style: ''
      },
      {
        name: '充值记录',
        path: '/Recharge',
        img: '../../static/percttent/hui/3.png',
        img2: '../../static/percttent/hei/3.png'
      },
      {
        name: '提现记录',
        path: '/Withdrawal',
        img: '../../static/percttent/hui/8.png',
        img2: '../../static/percttent/hei/8.png'
      },
      {
        name: '消费记录',
        path: '/Consumption',
        img: '../../static/percttent/hui/4.png',
        img2: '../../static/percttent/hei/4.png'
      },
      {
        name: '实名认证',
        path: '/Real_name',
        img: '../../static/percttent/hui/5.png',
        img2: '../../static/percttent/hei/5.png'
      },
      {
        name: '安全中心',
        path: '/security',
        img: '../../static/percttent/hui/6.png',
        img2: '../../static/percttent/hei/6.png'
      },
      {
        name: '转账中心',
        path: '/Transfer',
        img: '../../static/percttent/hui/7.png',
        img2: '../../static/percttent/hei/7.png'
      }
      ]
    }
  },
  methods: {
    fClose () {
      this.$cookieStore.delCookie('user_sess')
      window.location.href = `${window.location.protocol}//${window.location.host}/#/Home`
      window.location.reload()
    }
  },
  mounted () {
    this.http.payzhouk().then(res => {
      let payzklist = res.data.data.timecard_list
      if (payzklist.length == 0) {
        this.routelist[1].style = 'display:none'
      } else {
        this.routelist[1].style = ''
      }
    })
  }
}
</script>
<style lang="scss">
.mean-container .mean-nav ul li a:nth-child(7) {
  background-color: rebeccapurple;
}
</style>



// WEBPACK FOOTER //
// src/components/CenterNavSun.vue